import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader.js";
import { animateEmissiveColor } from "./script.js";
import gsap from "gsap";
import {
  setupSacrificeButton,
  fetchDeathReason,
  triggerAnimation,
} from "./controller.js";
let loginClickable = false;
export let mixer,
  step1,
  step2,
  step3,
  hover,
  login,
  yes,
  uiModel,
  gltfObject,
  youwill;
export function createUIScene(canvas) {
  // Raycaster and mouse setup
  const raycaster = new THREE.Raycaster();
  const mouse = new THREE.Vector2();

  // Detect if the user is on a mobile device
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  window.addEventListener("mousemove", (event) => {
    if (isMobile) {
      console.log("it s mobil");
      // On mobile, keep the hover material's opacity consistent
      if (step1 && step1.visible && hover && hover.material) {
        hover.material.opacity = 0.5; // Always show hover effect
      } else if (step2 && step2.visible && hover && hover.material) {
        hover.material.opacity = 0.5; // Always show hover effect
      } else if (hover && hover.material) {
        hover.material.opacity = 0.5; // Reset to default state
      }
      return; // Exit early for mobile
    }

    // For non-mobile devices, handle the hover with mouse movement
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

    raycaster.setFromCamera(mouse, camera);
    const intersects = raycaster.intersectObjects(scene.children, true);

    // Reset hover material to default opacity

    if (step1 && step1.visible) {
      if (hover && hover.material) {
        hover.material.opacity = 0.5; // Default state for hover material
      }
      intersects.forEach((intersect) => {
        if (intersect.object === login) {
          hover.material.opacity = 1; // Apply hover effect
        }
      });
    }

    if (step2 && step2.visible) {
      if (hover && hover.material) {
        hover.material.opacity = 0.5; // Default state for hover material
      }
      intersects.forEach((intersect) => {
        if (intersect.object === yes) {
          hover.material.opacity = 0.5; // Apply hover effect
        }
      });
    }
  });

  // Mouse click event listener for click detection
  const handleInteraction = (event) => {
    // Normalize mouse/touch position
    let clientX, clientY;

    if (event.touches) {
      // Mobile touch event
      clientX = event.touches[0].clientX;
      clientY = event.touches[0].clientY;
    } else {
      // Desktop mouse event
      clientX = event.clientX;
      clientY = event.clientY;
    }

    mouse.x = (clientX / window.innerWidth) * 2 - 1;
    mouse.y = -(clientY / window.innerHeight) * 2 + 1;

    // Perform raycasting
    raycaster.setFromCamera(mouse, camera);
    const intersects = raycaster.intersectObjects(scene.children, true);

    // Check interactions
    intersects.forEach((intersect) => {
      if (step1 && step1.visible) {
        if (
          intersect.object === login &&
          !login.userData.triggered &&
          loginClickable
        ) {
          console.log("Login clicked!");
          login.userData.triggered = true;
          triggerAnimation();
        }
      }
      if (step2 && step2.visible) {
        if (intersect.object === yes) {
          console.log("yes clicked!");
          setupSacrificeButton();
        }
      }
    });
  };

  // Add event listeners for both desktop and mobile
  window.addEventListener("mousedown", handleInteraction); // Desktop
  window.addEventListener("touchstart", handleInteraction, { passive: true }); // Mobile
  /**
   * Scene and Camera
   */
  const scene = new THREE.Scene();
  const sizes = {
    width: window.innerWidth,
    height: window.innerHeight,
  };

  const aspect = sizes.width / sizes.height;
  const frustumSize = 10; // Controls the zoom level for the orthographic camera
  const rgbeLoader = new RGBELoader();
  rgbeLoader.load(
    "./thatch_chapel_1k.hdr",
    (environmentMap) => {
      environmentMap.mapping = THREE.EquirectangularReflectionMapping;
      scene.environment = environmentMap;
    },
    undefined,
    (error) => {
      console.error("Error loading environment map:", error);
    }
  );

  /**
   * Orthographic Camera
   */
  const camera = new THREE.OrthographicCamera(
    (-frustumSize * aspect) / 2, // left
    (frustumSize * aspect) / 2, // right
    frustumSize / 2, // top
    -frustumSize / 2, // bottom
    0.1, // near plane
    100 // far plane
  );
  camera.position.set(0, 0, 1); // Set camera position
  camera.lookAt(0, 0, 0);
  scene.add(camera);

  /**
   * Renderer
   */
  const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true,
    alpha: true, // Enable transparency for the background
  });
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  renderer.setClearColor(0xffffff, 0);

  renderer.toneMapping = THREE.ReinhardToneMapping;
  renderer.toneMappingExposure = 1;

  /**
   * GLTF Model
   */

  const gltfLoader = new GLTFLoader();
  gltfLoader.load(
    "/models/scene (11).glb",
    (gltf) => {
      gltfObject = gltf;
      uiModel = gltf.scene;
      uiModel.scale.set(2.75, 2.75, 2.75);
      uiModel.position.y -= 3;
      step1 = uiModel.getObjectByName("textStep1");
      step2 = uiModel.getObjectByName("textStep2");
      step3 = uiModel.getObjectByName("textStep2001");
      hover = uiModel.getObjectByName("hover1");
      login = uiModel.getObjectByName("login"); // Retrieve the "login" mesh
      setTimeout(() => {
        loginClickable = true;
      }, 4000);
      if (login && login.material) {
        const textureLoader = new THREE.TextureLoader();
        textureLoader.load("/textures/enter.png", (texture) => {
          texture.flipY = false; // Ensure correct orientation
          login.material.map = texture;
          login.material.needsUpdate = true;
        });
      }
      // Flip the login texture (UVs) vertically
      // Flip the login mesh on the Y-axis
      if (login && login.scale) {
        login.scale.y *= -1;
      }
      yes = uiModel.getObjectByName("yes");
      youwill = uiModel.getObjectByName("youWill001");
      if (youwill) {
        youwill.material.transparent = true;
        youwill.material.opacity = 0;
      }
      // checkAuthStatus(step1, step2);
      if (hover && hover.isMesh && hover.material) {
        hover.material.transparent = true;
        hover.material.opacity = 0.5;
      }
      if (isMobile) {
        hover.material.opacity = 0.5;
      }
      step1.visible = true;
      step2.visible = false;
      step3.visible = false;
      uiModel.getObjectByName("RollR").material.depthWrite = true;
      uiModel.getObjectByName("occR").material.colorWrite = false;
      uiModel.getObjectByName("tell").material.color = new THREE.Color(
        0x0f0f0f
      );
      uiModel.getObjectByName("tell").material.color = new THREE.Color(
        0x0f0f0f
      );
      uiModel.getObjectByName("tell").material.color = new THREE.Color(
        0x0f0f0f
      );
      uiModel.getObjectByName("tell").material.color = new THREE.Color(
        0x0f0f0f
      );
      uiModel.getObjectByName("login").position.z = 0.175;
      uiModel.getObjectByName("frame2").scale.z = 0.4;
      uiModel.getObjectByName("hover2").scale.z = 0.4;
      uiModel.getObjectByName("frame2").position.z = 0.28;
      uiModel.getObjectByName("hover2").position.z = 0.28;
      uiModel.getObjectByName("yes").position.z = 0.28;
      const frame = uiModel.getObjectByName("frame");

      if (frame && frame.isMesh && frame.material) {
        // Copy the map to the emissiveMap
        frame.material.color = new THREE.Color(0x2f2f2f);

        // Set emissive color and intensity
        // frame.material.emissive = new THREE.Color(0xffffee); // Red color
        // frame.material.emissiveIntensity = 1.0; // Adjust intensity as needed

        // Enable emissive if not already enabled
        frame.material.needsUpdate = true;
      }
      mixer = new THREE.AnimationMixer(uiModel);

      // Find and play the animation named "Animation" after a 1-second delay
      const animationClip = THREE.AnimationClip.findByName(
        gltf.animations,
        "Animation"
      );
      if (animationClip) {
        setTimeout(() => {
          const action = mixer.clipAction(animationClip);
          action.setLoop(THREE.LoopOnce); // Set loop mode if needed
          action.clampWhenFinished = true;
          action.play(); // Play the animation
        }, 2000); // 1-second delay
      }
      scene.add(uiModel);
    },
    undefined,
    (error) => {
      console.error("Error loading UI model:", error);
    }
  );

  /**
   * Lights
   */
  const light = new THREE.DirectionalLight(0xffffff, 1);
  light.position.set(5, 5, 5);
  scene.add(light);

  /**
   * Resize Handling
   */
  window.addEventListener("resize", () => {
    // Update sizes
    sizes.width = window.innerWidth;
    sizes.height = window.innerHeight;

    // Update camera aspect ratio
    const aspect = sizes.width / sizes.height;
    camera.left = (-frustumSize * aspect) / 2;
    camera.right = (frustumSize * aspect) / 2;
    camera.top = frustumSize / 2;
    camera.bottom = -frustumSize / 2;
    camera.updateProjectionMatrix();

    // Update renderer size
    renderer.setSize(sizes.width, sizes.height);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  });

  /**
   * Animation Loop
   */
  const clock = new THREE.Clock();
  const tick = () => {
    const delta = clock.getDelta();
    if (mixer) mixer.update(delta);
    // Raycasting

    raycaster.setFromCamera(mouse, camera);
    const intersects = raycaster.intersectObjects(scene.children, true);
    if (!isMobile) {
      // Reset hover material to default opacity

      // Check if the mouse is over the login mesh
      if (step1 && step1.visible) {
        if (hover && hover.material) {
          hover.material.opacity = 0.5;
        }
        // Apply hover effect on login
        if (step1 && step1.visible) {
          // Allow clicks on login
          intersects.forEach((intersect) => {
            if (intersect.object === login) {
              hover.material.opacity = 1;
              // Add custom click logic here
            }
          });
        }
      }
      if (step2 && step2.visible) {
        if (hover && hover.material) {
          hover.material.opacity = 0.5;
        }
        // Apply hover effect on login
        if (step2 && step2.visible) {
          // Allow clicks on login
          intersects.forEach((intersect) => {
            if (intersect.object === yes) {
              hover.material.opacity = 1;
              // Add custom click logic here
            }
          });
        }
      }
    }

    renderer.render(scene, camera);
    requestAnimationFrame(tick);
  };

  tick();
}
let isListenerAdded = false;
let animationPlayed = false;
export function lastScene(uiModel, step1, step2, gltfObject, youwill) {
  if (!uiModel || !step1 || !step2) {
    console.error("Missing required parameters for lastScene.");
    return;
  }

  const mixer = new THREE.AnimationMixer(uiModel);

  const reverseAnimationClip = THREE.AnimationClip.findByName(
    gltfObject.animations,
    "Animation"
  );
  if (!reverseAnimationClip) {
    console.error('Animation "Animation" not found in the model.');
    return;
  }

  const reverseAction = mixer.clipAction(reverseAnimationClip);
  reverseAction.setLoop(THREE.LoopOnce);
  reverseAction.clampWhenFinished = true;
  reverseAction.timeScale = -1;
  reverseAction.reset();
  reverseAction.time = reverseAnimationClip.duration;
  reverseAction.play();

  // Add the listener only if it hasn't been added already
  if (!isListenerAdded) {
    mixer.addEventListener("finished", () => {
      console.log("Reverse animation finished");

      step1.visible = false;
      // step2.visible = true;

      gsap.to(login.material, {
        opacity: 0,
        delay: 1,
        duration: 1, // Animation duration in seconds
        onUpdate: () => {
          login.material.needsUpdate = true; // Ensure material updates
        },
        onComplete: () => {
          console.log("Opacity animation completed");
        },
      });
      const forwardAction = mixer.clipAction(reverseAnimationClip);
      forwardAction.timeScale = 1;
      forwardAction.setLoop(THREE.LoopOnce);
      forwardAction.clampWhenFinished = true;
      forwardAction.reset();
      forwardAction.play();
      // if (youwill && youwill.material) {
      //   youwill.material.opacity = 0; // Ensure opacity starts at 0
      //   youwill.material.transparent = true; // Ensure material supports transparency

      //   // GSAP animation for opacity
      //   gsap.to(youwill.material, {
      //     opacity: 1,
      //     delay: 1,
      //     duration: 3, // Animation duration in seconds
      //     onUpdate: () => {
      //       youwill.material.needsUpdate = true; // Ensure material updates
      //     },
      //     onComplete: () => {
      //       console.log("Opacity animation completed");
      //     },
      //   });
      // }
      mixer.addEventListener("finished", () => {
        animationPlayed = true;
      });
      console.log("Forward animation started");
    });

    isListenerAdded = true; // Mark the listener as added
  }

  const clock = new THREE.Clock();
  function animate() {
    if (!animationPlayed) {
      const delta = clock.getDelta();
      mixer.update(delta);

      requestAnimationFrame(animate);
    }
  }
  animate();
}
